import { Box, Grid } from "@mui/material";
import { OurTeamMechanicInfo, Team_Members } from "../../../Utils/Constants";
import EmailFill from "../../../assets/img/svg/mail-fill.svg";
import InfoIconFill from "../../../assets/img/svg/info-fill.svg";
import LinkedinFill from "../../../assets/img/svg/linkedin-fill.svg";
import { useEffect, useRef, useState } from "react";
import PAULPRINCE from "../../../assets/img/images/PAUL_PRINCE.jpg";
import LORANZOKIMPE from "../../../assets/img/images/LORANZO_KIMPE.png";

const MembersCard = ({ item, findSectionBySectionId }) => {
  const [readmore, setReadmore] = useState(false);
  return (
    <Grid container item spacing={4} mb={"30px"}>
      <Grid item xs={12} sm={12} md={12} lg={3}>
        <img
          src={item.avtar}
          alt="avtar"
          style={{
            width: "100%",
            objectFit: "cover",
            height: "362px",
            objectPosition: "top",
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={9}>
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Box>
            <Box className="Members_Title">
              {findSectionBySectionId({
                sectionId: item.titleSectionId,
                String: item.title,
              })}
            </Box>
            <Box className="Members_Sub_Title">
              {findSectionBySectionId({
                sectionId: item.subTitleSectionId,
                String: item.subTitle,
              })}
            </Box>
          </Box>
          <Box display={"flex"} alignItems={"center"}>
            {item.emailSectionId && (
              <a
                href={`mailto:${findSectionBySectionId({
                  sectionId: item.emailSectionId,
                  String: item.email,
                  isLink: true,
                })}`}
              >
                <Box className="email-fill-icon">
                  <img src={EmailFill} alt="" />
                </Box>
              </a>
            )}
            {item.linkedinSectionId && (
              <a
                href={findSectionBySectionId({
                  sectionId: item.linkedinSectionId,
                  String: item.linkedin,
                  isLink: true,
                })}
                target="_blank"
              >
                <Box className="email-fill-icon">
                  <img src={LinkedinFill} alt="" />
                </Box>
              </a>
            )}
          </Box>
        </Box>
        {!readmore ? (
          <>
            <Box className="Members_Dec">
              {findSectionBySectionId({
                sectionId: item.shortAboutP1,
                String: item?.about_1,
              })}
            </Box>

            <Box className="Members_Dec">
              {findSectionBySectionId({
                sectionId: item.shortAboutP2,
                String: item?.about_2,
              })}{" "}
              {!item.noReadMore && (
                <h100
                  style={{
                    cursor: "pointer",
                    color: "#FACD40",
                    textDecoration: "underline",
                  }}
                  onClick={() => {
                    setReadmore(true);
                  }}
                >
                  Read More
                </h100>
              )}
            </Box>
          </>
        ) : (
          <Box className="Members_Dec">
            {findSectionBySectionId({
              sectionId: item.fullBioSectionId,
              String: item?.fullBio,
            })}
            {/* <span
              style={{ cursor: "pointer", color: "#FACD40", textDecoration: "underline" }}
              onClick={() => {
                setReadmore(true);
              }}
            >
              Read Less
            </span> */}
          </Box>
        )}
      </Grid>
    </Grid>
  );
};

const OurTeamMembers = ({ findSectionBySectionId }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const hoverRef = useRef(null);

  // Close hover-content when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (hoverRef.current && !hoverRef.current.contains(event.target)) {
        setActiveIndex(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <Box
        className="Our_Team_Members"
        sx={{
          paddingY: {
            xs: "40px", // For extra small screens (mobile)
            sm: "60px", // For small screens (tablets)
            md: "80px", // For medium screens (laptops)
            lg: "100px", // For large screens (desktops)
          },
        }}
      >
        <Box className="container">
          <Box className="Our_Team_Members_Text" mb={"30px"}>
            {findSectionBySectionId({
              sectionId: 10,
              String: "Our Team Members",
            })}
          </Box>

          <Box>
            {Team_Members.map((item) => {
              return (
                <MembersCard
                  item={item}
                  findSectionBySectionId={findSectionBySectionId}
                />
              );
            })}

            <MembersCard
              item={{
                title: "PAUL PRINCE",
                subTitle: "SHOP LEAD HAND",
                about_1: findSectionBySectionId({
                  sectionId: 1,
                  String:
                    "Paul was born and raised in London, ON and has been with Marcel Equipment for 14 years. Paul started out his career as a car mechanic until his father showed him a job posting for heavy machinery work in the local newspaper. He did his schooling and has never looked back. His favorite thing about working at MEL are the challenges and problem solving that differs every day working on all different machines.",
                  corssCheck: true,
                }),
                about_2: findSectionBySectionId({
                  sectionId: 10000,
                  String:
                    "Outside of work, Paul enjoys tobogganing with his wife & young son. He also loves to travel to Mexico to the warm beaches and get some relaxing in. Fun fact about Paul, he is oddly athletic but doesn’t play any sports. Paul is an invaluable and respected asset to our team with his wealth of knowledge",
                  corssCheck: true,
                  corssCheckId: 1,
                }),

                email: "paulp@marcelequipment.com",
                avtar: PAULPRINCE,
                noReadMore: true,

                titleSectionId: 30,
                subTitleSectionId: 31,
                shortAboutP1: 32,
                shortAboutP2: 33,
              }}
              findSectionBySectionId={findSectionBySectionId}
            />

            <MembersCard
              item={{
                title: "LORANZO KIMPE",
                subTitle: "SHOP LEAD HAND/TECHNICAL ADVISOR",
                about_1: findSectionBySectionId({
                  sectionId: 2,
                  String:
                    "Loranzo was born in Strathroy, ON & has been in London for the past 30 years. He has been with Marcel Equipment for 14 years. Loranzo worked for 18 years at Caterpillar and therefore came with a wealth of knowledge when it comes to heavy machinery. Especially growing up around the machines, his Dad owned 5 D8’s! His favorite thing about working at MEL is problem solving the machines & the people he works with. ",
                  corssCheck: true,
                }),
                about_2: findSectionBySectionId({
                  sectionId: 10000,
                  String:
                    "Outside of work, Loranzo enjoys riding his Harley, eating his wife’s homemade meals & camping. Loranzo is a respected leader to our team and we are lucky to have him.",
                  corssCheck: true,
                  corssCheckId: 2,
                }),

                email: "paulp@marcelequipment.com",
                avtar: LORANZOKIMPE,
                noReadMore: true,

                titleSectionId: 30,
                subTitleSectionId: 31,
                shortAboutP1: 32,
                shortAboutP2: 33,
              }}
              findSectionBySectionId={findSectionBySectionId}
            />
          </Box>

          <Box
            sx={{
              paddingTop: {
                xs: "40px", // For extra small screens (mobile)
                sm: "60px", // For small screens (tablets)
                md: "80px", // For medium screens (laptops)
                lg: "100px", // For large screens (desktops)
              },
            }}
          >
            <Grid
              container
              item
              spacing={4}
              mb={"30px"}
              justifyContent={"center"}
            >
              {OurTeamMechanicInfo.map((item, index) => {
                return (
                  <>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <Box
                        position={"relative"}
                        ref={hoverRef}
                        // sx={{
                        //   "&:hover .hover-content": { opacity: 1, visibility: "visible" },
                        // }}
                      >
                        <img
                          src={item?.avtar}
                          alt=""
                          style={{
                            width: "100%",
                            height: "362px",
                            objectFit: "cover",
                            objectPosition: "top",
                          }}
                        />

                        <Box
                          position={"absolute"}
                          sx={{
                            width: "-webkit-fill-available",
                            height: "-webkit-fill-available",
                            top: 0,
                            background:
                              " linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, #000000 100%)",
                          }}
                        >
                          <Box
                            display={"flex"}
                            justifyContent={"space-between"}
                            flexDirection={"column"}
                            height={"-webkit-fill-available"}
                          >
                            <Box
                              display={"flex"}
                              justifyContent={"end"}
                              pr={"20px"}
                              pt={"20px"}
                            >
                              {item.emailSectionId && (
                                <a
                                  href={`mailto:${findSectionBySectionId({
                                    sectionId: item.emailSectionId,
                                    String: item.email,
                                    isLink: true,
                                  })}`}
                                >
                                  <Box className="email-fill-icon">
                                    <img src={EmailFill} alt="" />
                                  </Box>
                                </a>
                              )}

                              {/* I button */}
                              <Box
                                className="info-fill-icon"
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent event bubbling
                                  setActiveIndex(
                                    activeIndex === index ? null : index
                                  );
                                }}
                              >
                                <img src={InfoIconFill} alt="" width={"27px"} />
                              </Box>
                            </Box>
                            <Box mb={"15px"}>
                              <Box
                                color={"#FACD40"}
                                className="Our_Team_title"
                                sx={{ textAlign: "center" }}
                              >
                                {findSectionBySectionId({
                                  sectionId: item.titleSectionId,
                                  String: item.title,
                                })}
                              </Box>
                              <Box
                                color={"#FFFFFF"}
                                className="Our_Team_Banner_Sub_Title"
                                sx={{ textAlign: "center" }}
                              >
                                {/* {item?.subTitle} */}
                                {findSectionBySectionId({
                                  sectionId: item.subTitleSectionId,
                                  String: item.subTitle,
                                })}
                              </Box>
                            </Box>
                          </Box>
                        </Box>

                        <Box
                          position={"absolute"}
                          className="hover-content"
                          // sx={{
                          //   width: "-webkit-fill-available",
                          //   height: "-webkit-fill-available",
                          //   top: 0,
                          //   background: " linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, #000000 100%)",
                          //   opacity: 0,
                          //   visibility: "hidden",

                          //   transition: "opacity 0.4s, visibility 0.4s",
                          // }}
                          sx={{
                            width: "100%",
                            height: "100%",
                            top: 0,
                            background:
                              "linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, #000000 100%)",
                            opacity: activeIndex === index ? 1 : 0,
                            visibility:
                              activeIndex === index ? "visible" : "hidden",
                            transition: "opacity 0.4s, visibility 0.4s",
                          }}
                        >
                          <Box
                            display={"flex"}
                            justifyContent={"space-between"}
                            flexDirection={"column"}
                            height={"-webkit-fill-available"}
                            sx={{ background: "#141215BF" }}
                            p={"20px 8px 20px 20px"}
                          >
                            <Box
                              className="Our_Team_Banner_Sub_Title"
                              sx={{
                                textAlign: "start",
                                fontWeight: "400",
                                overflowY: "auto",
                              }}
                              color={"#FFFFFF"}
                            >
                              {/* {item?.about_1} */}
                              {findSectionBySectionId({
                                sectionId: item.shortAboutP1,
                                String: item?.about_1,
                              })}
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                  </>
                );
              })}
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
};
export default OurTeamMembers;
